<template>
  <div class="menu">
    <nav class="menu-items">
      <ul>
        <item
          v-for="(item, index) in data"
          :key="index"
          v-bind="{ item, open, activeItem }"
          @clickItem="clickItem"
          @close="close"
        />
      </ul>
    </nav>
    <div class="mobile-menu">
      <div class="menu-btn" @click="toggleMobile" :class="{ active: mobile }">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
      </div>
      <div class="backdrop" v-if="mobile">
        <div class="inner-wrapper">
          <ul class="mobile-items">
            <item
              v-for="(item, index) in data"
              :key="index"
              v-bind="{ item, open, activeItem }"
              @clickItem="clickItem"
              @close="close"
            />
          </ul>
          <ul class="bottom_bar">
            <item
              v-for="(item, index) in bottom_bar_data"
              :key="index"
              v-bind="{ item, open, activeItem }"
              @clickItem="clickItem"
              @close="close"
            />
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import item from "./item.vue";

export default {
  components: { item },
  props: {
    items: { required: true },
    bottom_bar: { required: true },
  },
  data() {
    return {
      open: false,
      activeItem: null,
      mobile: false,
    };
  },
  computed: {
    data: (t) => t.items.map((x) => JSON.parse(x)),
    bottom_bar_data: (t) => t.bottom_bar.map((x) => JSON.parse(x)),
  },
  methods: {
    clickItem(item) {
      this.open = true;
      this.activeItem = item;
    },
    close() {
      this.open = false;
      this.activeItem = null;
    },
    toggleMobile() {
      this.mobile = !this.mobile;

      if (this.mobile) {
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
      } else {
        document.body.style.position = "unset";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.menu {
  @include res(tab-l) {
  }
}

.menu-items {
  display: block;

  @include res(tab-l) {
    display: none;
  }

  ul &::v-deepli:last-child a {
    color: $brown;
  }
}

.mobile-menu {
  -webkit-overflow-scrolling: touch;

.menu-btn {
  display: none;
  width: 26px;
  cursor: pointer;
  position: relative; /* Add position relative for proper rotation */

  @include res(tab-l) {
    display: block;
  }

  .bar {
    background-color: $medium-grey; /* Define your color variable */
    height: 2.5px;
    display: block;
    margin-bottom: 4px;
    transition: all 300ms cubic-bezier(0.34, -0.44, 0.64, 1.56);

    /* Set initial rotation for hamburger bars */
    &:nth-child(1) {
      transform-origin: center;
    }

    &:nth-child(2) {
      transform-origin: center;
    }

    &:nth-child(3) {
      transform-origin: center;
    }
  }

  /* Rotate bars when the "active" class is added */
  &.active .bar:nth-child(1) {
    transform: translateY(7px) rotate(45deg);
  }

  &.active .bar:nth-child(2) {
    transform: scaleX(0);
  }

  &.active .bar:nth-child(3) {
    transform: translateY(-6px) rotate(-45deg);
  }
}



  .backdrop {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    width: 100%;
    margin-top: 85px;
    background-color: $white;
    -webkit-overflow-scrolling: touch;
    border-top: 1px solid #eeeeee;
    height: calc(100vh - 85px);
    overflow: scroll;

    .close-btn {
      width: 18px;
      height: 18px;
      color: $white;
      position: absolute;
      top: 7%;
      right: 10%;
      cursor: pointer;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    .inner-wrapper {
      flex: 1;
      width: 100%;
      overflow: hidden;
      padding-bottom: 110px;
    }
  }
}
</style>
